<script setup lang="ts">
import fpsImg from '@/assets/fps-qrcode.jpg'
import paymeImg from '@/assets/payme-qrcode.jpg'
import _service from '@/service';
import { isStarNest, webviewClose } from '@/utils/starnest';
import { Uploader, showToast } from 'vant';
import { ref } from 'vue';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
const {t} = useI18n()
const route = useRoute()
const router = useRouter()
const productParams = ref<any>()
const payType = ref<string>('payme')
const fileList = ref<any>([])
onMounted(() => {
  const params: any = route.query.params || ''
  // if (!sessionStorage.getItem('PAYMENT_DATA')) {
  //   sessionStorage.setItem('PAYMENT_DATA',params)
  //   const url = `${window.location.origin}${window.location.pathname}`
  //   window.location.href = url
  //   return false
  // }
  // const PAYMENT_DATA:any = sessionStorage.getItem('PAYMENT_DATA')
  productParams.value = JSON.parse(params)
  console.log(productParams.value);
  payType.value = productParams.value.payChannel === 'fps_pay' ? 'fps' : 'payme'
})

const uploadFile = async(data:any) => {
  let file = data.file
  // 此时可以自行将文件上传至服务器
  let fileName = file.name;  // 保存文件名
  let fileName2 = fileName.split('.');  // 对文件名进行切割
  //var renameFile =new File([原文件], 新文件名,文件类型);
  var renameFile =new File([file], `${productParams.value.no}` + '.' + fileName2[1],{type:file.type});

  var formdata = new FormData();
  formdata.append('file', renameFile);
  try {
    data.status = 'uploading';
    data.message = `${t('Uploading')}...`;
    const res = await _service.uploadOrderImg(formdata)
    // fileList.value.push(data.origin_url)
    data.status = '';
    data.message = '';
  } catch (error) {
    console.log(error);
    
  }
}

const submitFn = () => {
  if (!fileList.value.length) {
    showToast(t('Upload payment voucher'))
    return false
  }
  showToast(t('Submission successful, please check the order later'))
  webviewClose()
}

const handleReturn = () => {
  router.back()
}

</script>

<template>
  <div class="otherpayment-layout">
    <div class="media-375">
      <div class="text">{{t('Amount')}}</div>
      <div class="number-font">{{(+productParams?.price).toFixed(2)}} {{productParams?.coin}}</div>
      <div class="qrcode-bar">
        <div>
          <div class="title">{{ payType === 'payme' ? `PAYME` : `VROOM EXPO COMPANY VROOM EXPO COMPANY LIMIT` }}</div>
          <div class="small-title">Payme scan code payment</div>
        </div>
        <div class="qr-code">
          <img :src="payType === 'payme' ? paymeImg : fpsImg" alt="">
        </div>
        <div class="order-sn number-font">
          {{t('Order ID')}}:{{productParams?.no}}
        </div>
      </div>
      <div class="upload">
        <div class="upload-text"><span style="color:#E43F5A">*</span>{{t('Upload payment voucher')}}</div>
        <Uploader class="uploader" :name="productParams?.no" v-model="fileList" :show-upload="!fileList.length" :after-read="uploadFile" />
      </div>
      <div class="button-group">
        <div class="button back-btn" @click="handleReturn">{{t('Return')}}</div>
        <div class="button submit-btn" @click="submitFn">{{t('Confirm submission')}}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.otherpayment-layout {
  height: 100%;
  min-height: 100vh;
  padding: 24px 16px;
  background: #1F212D;
  color: #fff;

  .text {
    font-size: 14px;
  }

  .number-font {
    color: #1CF2E4;
    font-size: 32px;
    font-weight: 700;
    margin-top: 8px;
  }

  .qrcode-bar {
    display: flex;
    width: 100%;
    height: 378px;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 24px;
    gap: 24px;
    margin-top: 24px;
    background: url(../../assets/order-card.png);
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 18px;

    .title {
      width: 60%;
      margin: 0 auto;
      text-align: center;
      color: #000;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      @include ellipsis;
    }

    .small-title {
      text-align: center;
      color: #9C9CAA;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      /* 133.333% */
    }

    .qr-code {
      width: 220px;
      height: 220px;
      padding: 10px;
      border-radius: 12px;
      background: #FFF;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .order-sn {
      color: #565662;
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
    }
  }
  .upload{
    .upload-text{
      margin-top: 24px;
      margin-bottom: 12px;
      font-size: 14px;
    }
    .uploader{
      :deep(.van-uploader__upload){
        border-radius: 12px;
      }
      :deep(.van-uploader__mask){
        border-radius: 12px;
      }
      :deep(.van-uploader__preview-image){
        border-radius: 12px;
      }
    }
  }
  .button-group{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    align-items: center;
    gap: 10px;
    background: #303342;
    :deep(.van-uploader__input-wrapper){
      width: 100%;
    }
    :deep(.van-uploader){
      width: 100%;
    }
    :deep(.van-uploader__wrapper){
      width: 100%;
    }
   
  }
  .button{
    display: flex;
    padding: 12px 10px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 12px;
    color:  #1CF2E4;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px; /* 150% */
    &.upload-btn {
      color: #070B14;
      background: linear-gradient(111deg, #FFF853 4.98%, #6EEF94 56.05%, #2AD8CD 95.37%);
      .camera{
        width: 20px;
        height: 20px;
        background: url(../../assets/camera.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    &.submit-btn {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      gap: 10px;
      color: #070B14;
      border-radius: 12px;
      background: linear-gradient(111deg, #FFF853 4.98%, #6EEF94 56.05%, #2AD8CD 95.37%);
    }
    &.back-btn{
      width: 124px;
      border-radius: 12px;
      background:  #1F212D;
    }
  }
}
</style>
